import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExcelImportService } from '../_services/excel-import.service';


@Component({
  selector: 'app-import-excel-data',
  templateUrl: './import-excel-data.component.html',
  styleUrls: ['./import-excel-data.component.css']
})
export class ImportExcelDataComponent implements OnInit {

  

  @ViewChild("fileSelector") fileSelector: ElementRef;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ImportExcelDataComponent>, public excelImportService: ExcelImportService) {

  }

  cancelClicked() {
    this.dialogRef.close(false);
  }

  submitClicked() {
    if (this.fileSelector != null) {
      var filePath = this.fileSelector.nativeElement.files[0];
      this.excelImportService.ImportExcelTemplateData(filePath, this.data);
    }

    this.dialogRef.close(true);
  }

  ngOnInit(): void {
  }

}
